import { FunctionBase } from '@models/DomainModels/Master/function-base';
import { ColDef } from 'ag-grid-enterprise';

interface GridColumnParams {
  t: (key: string) => string;
}

export const gridColumnDefinitions = ({ t }: GridColumnParams): ColDef<FunctionBase>[] => {
  const columns: ColDef<FunctionBase>[] = [
    {
      field: 'name',
      flex: 1,
      filter: 'agSetColumnFilter',
      filterParams: { caseSensitive: false, applyMiniFilterWhileTyping: true },
      headerName: t('headers.name')
    }
  ];

  return columns;
};
